import { useState } from "react";
import { CheckCircle2, HelpCircle, Loader2, Sparkles, X } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Checkbox } from "@/components/ui/checkbox";

export default function AiSortPreview({ rows, busy, onCancel, onConfirm }) {
  const [skip, setSkip] = useState(new Set());
  const matched = rows.filter((r) => r.customer_key);
  const toFile = matched.filter((r) => !skip.has(r.id));
  const toggle = (id) => setSkip((s) => { const n = new Set(s); n.has(id) ? n.delete(id) : n.add(id); return n; });

  return (
    <div className="mt-4 border rounded-lg bg-card" data-testid="ai-sort-preview">
      <div className="px-4 py-3 flex flex-wrap items-center gap-3 border-b">
        <p className="text-sm flex items-center gap-2"><Sparkles size={15} className="text-violet-400" />
          <span><span className="font-bold text-emerald-400">{matched.length}</span> of {rows.length} read & matched · <span className="text-amber-400">{rows.length - matched.length}</span> no match</span>
        </p>
        <div className="ml-auto flex gap-2">
          <Button size="sm" variant="ghost" onClick={onCancel} disabled={busy} data-testid="ai-sort-cancel"><X size={14} /> Cancel</Button>
          <Button size="sm" onClick={() => onConfirm(toFile)} disabled={busy || !toFile.length} data-testid="ai-sort-confirm" className="hover:bg-blue-600 hover:text-white">
            {busy ? <Loader2 size={14} className="animate-spin" /> : <CheckCircle2 size={14} />} File {toFile.length || ""} scan{toFile.length === 1 ? "" : "s"}
          </Button>
        </div>
      </div>
      <div className="divide-y max-h-80 overflow-y-auto text-sm">
        {rows.map((r, i) => (
          <div key={r.id} className="px-4 py-2 flex items-center gap-3" data-testid={`ai-sort-row-${i}`}>
            <Checkbox checked={!!r.customer_key && !skip.has(r.id)} disabled={!r.customer_key} onCheckedChange={() => toggle(r.id)} data-testid={`ai-sort-pick-${i}`} />
            {r.customer_key ? <CheckCircle2 size={15} className="text-emerald-400 shrink-0" /> : <HelpCircle size={15} className="text-amber-400 shrink-0" />}
            <div className="min-w-0 flex-1">
              <p className="font-mono text-xs truncate" title={r.filename}>{r.filename}</p>
              <p className="text-[11px] text-muted-foreground truncate">
                {r.error ? r.error : `Read: ${r.read_name || "—"}${r.read_invoice ? ` · #${r.read_invoice}` : ""}`}
              </p>
            </div>
            <span className={`text-xs truncate max-w-[40%] ${r.customer_key ? "" : "text-amber-400"}`} data-testid={`ai-sort-customer-${i}`}>
              {r.customer_name ? `→ ${r.customer_name}` : "No match"}
            </span>
          </div>
        ))}
      </div>
    </div>
  );
}
